// extracted by mini-css-extract-plugin
export default {"commonRoundedButtonLink":"_qMJ7","commonRoundedButton":"Y_yUb","buttonAction":"YM0nl Y_yUb","buttonLink":"Mykeh _qMJ7 YM0nl Y_yUb"};